import React from 'react';

import { Link, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CustomFieldEdit from 'common/components/products/CustomFieldEdit';
import ProductActionsFormatter from 'common/components/products/ProductActionsFormatter';
import { useBreakpoint } from 'common/hooks';

const ProductColumns = ({
    filterData,
    handleClickBulkItems,
    handleClickDuplicate,
    handleClickUpdate,
    rowModesModel,
    selectedRowId,
    setRowModesModel,
    setSelectedRowId,
}) => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();

    const nameColumn = [
        {
            align: 'left',
            display: 'flex',
            editable: true,
            field: 'name',
            flex: 1,
            headerName: t('Name'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Link
                        color="secondary"
                        component="button"
                        onClick={() => handleClickUpdate(row)}
                        underline="hover"
                        sx={{ textAlign: 'left', color: '#424242' }}
                    >
                        <Typography fontWeight="bold" variant="caption">
                            {row.name}
                        </Typography>
                    </Link>
                );
            },
            renderEditCell: (params) => {
                return (
                    <CustomFieldEdit
                        rowModesModel={rowModesModel}
                        setRowModesModel={setRowModesModel}
                        {...params}
                    />
                );
            },
        },
    ];

    let columns = [
        {
            align: 'left',
            display: 'flex',
            editable: true,
            field: 'code',
            flex: 1,
            headerName: t('Code'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography fontWeight="bold" variant="caption">
                        {row.code}
                    </Typography>
                );
            },
            renderEditCell: (params) => {
                return (
                    <CustomFieldEdit
                        rowModesModel={rowModesModel}
                        setRowModesModel={setRowModesModel}
                        {...params}
                    />
                );
            },
        },
        ...nameColumn,
        {
            align: 'left',
            display: 'flex',
            field: 'created_at',
            headerName: t('Discharge date'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">{row.created_at}</Typography>
                );
            },
            width: 180,
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = nameColumn;
    }

    columns = [
        ...columns,
        {
            align: 'left',
            display: 'flex',
            field: '',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <ProductActionsFormatter
                        filterData={filterData}
                        handleClickBulkItems={handleClickBulkItems}
                        handleClickDuplicate={handleClickDuplicate}
                        handleClickUpdate={handleClickUpdate}
                        row={row}
                        rowModesModel={rowModesModel}
                        selectedRowId={selectedRowId}
                        setRowModesModel={setRowModesModel}
                        setSelectedRowId={setSelectedRowId}
                    />
                );
            },
            sortable: false,
            width: 100,
        },
    ];

    return columns;
};

ProductColumns.propTypes = {
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickDuplicate: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    productKey: PropTypes.string,
    rowModesModel: PropTypes.object,
    selectedRowId: PropTypes.func,
    setRowModesModel: PropTypes.func,
    setSelectedRowId: PropTypes.func,
};

export default ProductColumns;
